import {createAction, props} from "@ngrx/store";

export const setConnectedUser = createAction(
  '[User] Set Connected User',
  props<{ user: any }>()
);
export const setIsPartnerAdmin = createAction(
  '[User] Set Is Partner Admin',
  props<{ isPartnerAdmin: boolean }>()
);
export const setIsMandataire = createAction(
  '[User] Set Is Mandataire',
  props<{ isMandataire: boolean }>()
);
export const setIsAcepPartner = createAction(
  '[User] Set Is Acep Partner',
  props<{ isAcepPartner: boolean }>()
);
export const setUserPartner = createAction(
  '[User] Set User Partner Admin',
  props<{ userPartner: any }>()
);

export const setUserCustomer = createAction(
  '[User] Set User Customer',
  props<{ userCustomer: any }>()
);
export const setUserPreference = createAction(
  '[User] Set User Preference',
  props<{ code: string, value: string }>()
);
export const setUserPreferences = createAction(
  '[User] Set User Preferences',
  props<{ userPreferences: { [code: string]: string } }>()
);
